import React, {Component} from 'react';

export class Roles extends Component {

    render() {
        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <h1>Roles</h1>
                        <p>TO DO</p>
                    </div>
                </div>
            </div>
        );
    }
}